module.exports = __webpack_public_path__ + "static/media/Image 1.7ad1bf82.png";